const config = {
    //Production // Real
    //API_URL: 'http://novitra.top:8080',
     API_URL: 'https://api-season.novitra.top',
    //development //coba-coba
    // API_URL: 'http://147.139.133.49:8081',
    //local bang epit
    // API_URL: 'http://192.168.18.4:8080',
    //API_URL: 'https://api-season.novitra.id',
};

export default config;
